<template>
  <div>
    <v-container fluid class="pa-0">
    </v-container>
    <v-container class="pa-0">
      <v-row no-gutters class="">
        <v-col cols="12" class="primary--text">
          <p class="headline font-weight-bold">{{ $t('titulo') }}</p>
          <p class="title">{{ $t('subtitulo') }}
          </p>
        </v-col>
      </v-row>
      <v-snackbar
          v-model="snackbar.mostrar"
          :color="snackbar.color"
          :multi-line="true"
          :timeout="snackbar.timeout"
          :top="true"
      >
        {{ snackbar.mensaje }}
        <v-btn
            dark
            text
            @click="snackbar.mostrar = false"
        >
          {{ $t('cerrar') | capitalize }}
        </v-btn>
      </v-snackbar>
      <v-row class="primary--text">
        <v-col cols="6">
          <p>{{ $t('p1') }}</p>
          <p>{{ $t('p2') }}</p>
          <p>{{ $t('p3') }}</p>
        </v-col>
        <v-col cols="6">
          <v-form ref="formOpinion" class="contacto">
            <v-text-field
                :label="$t('label_nombre')"
                v-model="nombre"
                filled
                color="primary"
                :rules="[requerido, counter3]"
                prepend-inner-icon="mdi-account"
            ></v-text-field>
            <v-text-field
                :label="$t('label_email')"
                v-model="correo"
                color="primary"
                :rules="[requerido, email]"
                type="email"
                filled
                prepend-inner-icon="mdi-at"
            ></v-text-field>
            <v-textarea
                v-model="comentario"
                color="primary"
                filled
                :rules="[requerido, counter6]"
                :label="$t('label_comentario')">
            </v-textarea>
          </v-form>
          <v-row>
            <v-col cols="12">
              <v-switch v-model="privacidad" color="secondary" class="d-inline primary--text"
                        :label="$t('acepto_politica')"></v-switch>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-0">
            <v-col cols="12" class="text-right pr-3">
              <v-btn color="primary" @click="enviarOpinion()" :disabled="!opinionValida()"
                     :loading="enviando">
                <span class="mr-2">{{ $t('enviar') | capitalize }}</span>
              </v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";

export default {
  name: 'OpinionPagina',
  components: {},
  data: () => ({
    nombre: null,
    correo: null,
    comentario: null,
    privacidad: false,
    enviando: false,
    snackbar: {
      mostrar: false,
      color: "success",
      timeout: 6000,
      msg: ""
    }
  }),
  methods: {
    requerido(value) {
      return !!value || this.$t('requerido')
    },
    counter6(value) {
      return !!value && value.length >= 6 || this.$t('minimo6')
    },
    counter3(value) {
      return !!value && value.length >= 3 || this.$t('minimo3')
    },
    email(value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || this.$t('req_email')
    },
    opinionValida() {
      if (this.nombre == null || this.nombre.length <= 2) return false;
      if (this.correo == null || this.correo.length <= 0) return false;
      if (this.comentario == null || this.comentario.length <= 5) return false;
      if (!this.privacidad) return false;

      return true;
    },
    enviarOpinion() {
      this.enviando = true;
      let params = {
        nombre: this.nombre,
        correo: this.correo,
        comentario: this.comentario,
        privacidad: this.privacidad,
      };

      HttpHelper.post("opinion/enviar", params)
          .then(() => {
            this.$refs.formOpinion.reset();
            this.privacidad = false;

            this.snackbar.color = "success";
            this.snackbar.timeout = 6000;
            this.snackbar.mensaje = this.$t("opinion_enviada");
            this.snackbar.mostrar = true;
          })
          .catch((error) => {
            this.snackbar.color = "error";
            this.snackbar.timeout = 0;
            this.snackbar.mensaje = error && Object.prototype.hasOwnProperty.call(error, 'mensaje')
                ? error.mensaje : this.$t('opinion_error');
            this.snackbar.mostrar = true;
          })
          .finally(() => {
            this.enviando = false;
          })
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  max-width: 1185px;
}
</style>

<style lang="scss">
form.contacto {
  .v-input__slot {
    background: #f7d9cd !important;
  }
}

.texto-rgpd {
  p {
    font-size: 11px;
    line-height: 12px;

  }
}
</style>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "titulo": "Tu opinión es importante",
    "subtitulo": "¡Gracias por colaborar!",
    "p1": "El desarrollo de una aplicación como SOLCONCER deriva en proceso complejo. Un gran equipo de personas ha trabajado intensamente en la elaboración de una metodología objetiva que permita la caracterización de soluciones constructivas.",
    "p2": "Pero el proceso no termina con la elaboración de una guía metodológica y el posterior desarrollo de esta aplicación. Queremos que con la opinión de los usuarios la herramienta pueda mejorar y adaptarse lo mejor posible a las necesidades de los usuarios.",
    "p3": "Por todo ellos a la derecha tienes un formulario con el que contarnos cualquier asunto en relación a SOLCONCER. De antemano el equipo que ha trabajado en el desarrollo agradece tu colaboración.",
    "danos_opinion": "Danos tu opinión",
    "label_nombre": "Nombre",
    "label_email": "Correo electrónico",
    "label_comentario": "Comentario...",
    "acepto_politica": "Acepto la política de protección de datos",
    "requerido": "Requerido",
    "minimo6": "Mínimo 6 carácteres",
    "minimo3": "Mínimo 3 carácteres",
    "req_email": "Correo electrónico incorrecto",
    "opinion_error": "Ha ocurrido un error desconocido al enviar el formulario.",
    "opinion_enviada": "Formulario enviado correctamente"
  }
}
</i18n>
<!-- @formatter:on -->